export enum SurfaceType {
  Manage = 'manage',
  Creator = 'creator',
  Inbox = 'inbox',
  QuickView = 'quickView',
  Form = 'form',
  Agent = 'agent',
  // Settings dashboards composed from navigation lists and editable
  // metadata-driven content-list sections.
  Settings = 'settings',
  // Editable financial document form (invoice, bill, quote, SO, PO).
  // Whole-document submit; mode = create | edit | preview. Nested repeats
  // for quote sections → items.
  FinancialDocument = 'financialDocument',
  // Record detail: header actions + save status, stacked body, optional right rail.
  // Works as a full page, a pseudo-page, or a hosted editor inside another Detail rail.
  Detail = 'detail',
  // Draft-based scheduling editor: extensible tabs, one validated whole-proposal submit.
  SchedulingEditor = 'schedulingEditor',
  // Draft-based flow editor: canvas, selected-item panel and issues list, one validated whole-definition submit.
  WorkflowEditor = 'workflowEditor',
}
